import { render, staticRenderFns } from "./InventoryBalance.vue?vue&type=template&id=66bc4656"
import script from "./InventoryBalance.vue?vue&type=script&lang=js"
export * from "./InventoryBalance.vue?vue&type=script&lang=js"
import style0 from "./InventoryBalance.vue?vue&type=style&index=0&id=66bc4656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports